import { redactAuthTelemetry } from "@/platform/api/redact-auth-url"
import { viewerUser } from "@/platform/observability/datadog/context"
import { redactPiiTelemetry } from "@/platform/observability/datadog/redact-url"

import type { LogsEvent } from "@datadog/browser-logs"

export const logsBeforeSend = (event: LogsEvent): boolean => {
  if (typeof event.viewer === "string") event.usr = viewerUser(event.viewer, event.usr)
  redactAuthTelemetry(event)
  redactPiiTelemetry(event)
  return true
}
